import { ConsentGoalDto } from '@act/shared/data-transfer-objects';
import { TaggableChip } from '../../../../display/TaggableChip/TaggableChip';
import { Box } from '@mui/material';
import { timeFormatter } from '@act/shared/utilities';

interface ConsentDateLineProps {
  consent: ConsentGoalDto;
}

export const ConsentDateLine = ({ consent }: ConsentDateLineProps) => {
  if (!consent.completedAt) {
    return null;
  }

  if (consent.completed && !consent.consented) {
    return <TaggableChip label="Rejected" color="error" isTag />;
  }

  const formattedDueDate = timeFormatter.epochToShortMonthDay(
    consent.completedAt
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
        paddingRight: '8px',
      }}
    >
      {formattedDueDate}
    </Box>
  );
};
